<!-- AI Start State -->
<div class="ai-chat-start">
  <div class="ai-start-content">
    <!-- Start Icon -->
    <div class="ai-start-icon">
      <i class="fa-solid fa-sparkles ai-start-icon"></i>
    </div>

    <!-- Start Title -->
    <h2 class="ai-start-title">
      {{ startTitle }}
    </h2>

    <!-- Start Description -->
    <p class="ai-start-description">
      {{ startDescription }}
    </p>

    <!-- Example Prompt Cards -->
    <div class="ai-example-prompts" *ngIf="showExamplePrompts && allExamplePrompts.length > 0">
      <div class="ai-example-cards-container">
        <rappider-card-icon-title-description-list
          [items]="getCardItems()"
          [compactCards]="true"
          (cardClick)="onCardClick($event)">
        </rappider-card-icon-title-description-list>
      </div>
    </div>

    <!-- Initial Input Container -->
    <div class="ai-initial-input-container">
      <textarea nz-input
                [nzAutosize]="{ minRows: 4, maxRows: 12 }"
                id="aiChatInput"
                class="ai-input-textarea"
                [(ngModel)]="currentMessage"
                [disabled]="isLoading"
                rows="4"
                [placeholder]="inputPlaceholder"
                (keydown)="onTextareaKeyDown($event)">
      </textarea>

      <!-- File Upload and Generate Button Row -->
      <div class="ai-start-actions-row">
        <!-- File Upload Section -->
        <div class="ai-file-upload-container">
          <rappider-multiple-file-upload [(ngModel)]="uploadedFiles"
                                         [config]="fileUploadConfig"
                                         [disabled]="isLoading">
          </rappider-multiple-file-upload>
        </div>

        <!-- Generate Button -->
        <div class="ai-generate-container">
          <rappider-button [text]="buttonText"
                           [type]="ButtonType.Primary"
                           [loading]="isLoading"
                           [disabled]="isLoading || (!currentMessage.trim() && (!uploadedFiles || uploadedFiles.length === 0))"
                           [icon]="{ name: 'fa-solid fa-sparkles', color: '#ffffff' }"
                           (click)="onStartClick()">
          </rappider-button>
        </div>
      </div>
    </div>
  </div>
</div>
